import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Authentication guard that protects routes from unauthorized access.
 *
 * If the user is not yet loaded, waits for the {@link AuthService} to finish
 * initializing before evaluating the authentication state.
 *
 * @returns {Promise<true | UrlTree>} `true` if the user is authenticated,
 * or a {@link UrlTree} redirecting to `/public` if not.
 */
export const authGuard: CanMatchFn = async () => {
  const router = inject(Router);
  const authService = inject(AuthService);
  await authService.waitUntilLoaded();

  if (authService.isAuthenticated()) {
    return true;
  }

  // Redirect to /public when user is not authenticated
  return router.createUrlTree(['/public']);
};
